<template>
  <footer class="invoice-create-footer">
    <div class="invoice-create-footer-right payment-receipt-create-footer-right">
      <button type="button" class="app-header-btn app-header-btn--primary" :disabled="submitting" @click="$emit('submit')">
        {{ text.create.ui.footerActions.submit }}
      </button>

      <button
        v-if="showCfdi"
        type="button"
        class="app-header-btn app-header-btn--success"
        :disabled="submitting || disableCfdi"
        @click="$emit('submit-cfdi')"
      >
        {{ text.create.ui.footerActions.submitCfdi }}
      </button>
    </div>
  </footer>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: paymentReceiptsText } = useDomainText('paymentReceipts');

export default {
  name: 'PaymentReceiptCreateFooterActions',
  props: {
    submitting: {
      type: Boolean,
      default: false,
    },
    disableCfdi: {
      type: Boolean,
      default: false,
    },
    showCfdi: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['submit', 'submit-cfdi'],
  data() {
    return {
      text: paymentReceiptsText,
    };
  },
};
</script>

<style scoped>
.payment-receipt-create-footer-right {
  width: 100%;
  justify-content: flex-end;
}
</style>
